module.exports = __webpack_public_path__ + "img/zfStoreBg.21995ef2.png";